// React
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import {Assignment, GetApp, } from '@material-ui/icons/';
import {functions} from 'constants/index';
// Api Services
import LoadingIndicator  from 'commons/LoadingIndicator';

import ApiServices from 'services/ApiServices';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import ListElement from './ListElement';
import BotonElement from 'components/BotonTable'; 
import NotAuthorized from 'commons/NotAuthorized';
import LoadingSpinner from 'components/LoadingSpinner';
import ModalObservation from 'components/ModalObservation';
import { ButtonGroup, IconButton } from '@material-ui/core';
import CustomToolTip from 'components/tooltip';

class SolicitudesCasosEspeciales extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            controller:'solicitudesDeEmpadronamiento',
            loading: false,
            authorized:true,
            checkAutorization:true,
            aceptarOpen: false,
            rechazarOpen: false,
            newCve:"",
            abrirModalAceptarSolicitud: false,
            abrirModalRechazoSolicitud: false,
            datosPadron:{},
            rowData: [],
            data: [],
            customActions:[],
            header: [
                { title: 'Solicitud No.', field: 'datosSolicitudEmpadronamiento.idSolicitud',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Completo', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }},
                { title: 'CUI', field: 'datosDpiSolicitudEmpadronamiento.cui' },
                { title: 'Pais Residencia', field: 'datosSolicitudEmpadronamiento.descripcionPaisResidencia.nombrePaisCorto' },
                { title: 'Estado Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelEstado'},
                { title: 'Ciudad Residencia', field: 'datosSolicitudEmpadronamiento.ciudadExtranjero.nombreDeCiudad',},
                { title: 'Departamento Residencia', field: 'departamentoResidencia.name'},
                { title: 'Municipio Residencia', field: 'municipioResidencia.name',},
                { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueModificada',},
                // { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueModificada', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento.fechaFueModificada)},
                { title: 'Hora modificó', field: 'datosSolicitudEmpadronamiento.horaFueModificada'},
                { title: 'Usuario modificó', field: 'datosSolicitudEmpadronamiento.usuarioMod'},
                { title: 'Origen', field: 'datosSolicitudEmpadronamiento.tipoOrigen'},
                { title: 'Tipo Solicitud', field: 'datosSolicitudEmpadronamiento.tipoSolicitud',},                
                { title: 'Nacional / Extranjero', field: 'datosSolicitudEmpadronamiento.nacionalExtranjero'},
                { title: 'Observación', field: 'datosSolicitudEmpadronamiento.observaciones', render: rowData =>
                    <div>
                            {(rowData.datosSolicitudEmpadronamiento.observaciones !== null) ? (
                                <IconButton  size="small" color="primary"
                                    onClick={() => {
                                        let observacion = []
                                        observacion.push({title: rowData.datosSolicitudEmpadronamiento?.observaciones, text:''})
                                        this.abrirObservacion();
                                        this.setState({ textoObservacion: observacion, title:'Observaciones' })
                                    }}
                                >
                                    <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                                </IconButton>
                            ) : ""}
                    </div>
                },                
                { title: 'Acción', field: 'accion',
                    render: rowData=><div>
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <CustomToolTip title="Procesar" ><Assignment/></CustomToolTip>
                            {/* <CustomToolTip title="Procesar Solicitud TSE Virtual" handleFunction={() => this.ComponenteModalTSEVirtual(rowData)}><Assignment/></CustomToolTip> */}
                        </ButtonGroup>                        
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
            openObservacion: false,
            textoObservacion: '', title: '',
        }
        this.showList = this.showList.bind(this);
        this.abrirObservacion = this.abrirObservacion.bind(this);
        this.cerrarObservacion = this.cerrarObservacion.bind(this);
    }
     
    async showList(){
        this.setState({data: []})
        try{
            this.setState({loading: true, checkAutorization: true});
            const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
            if (hasPermission.error){
                this.setState({checkAutorization: false,authorized: false,loading: false });
            }else{
                ApiServices[this.state.controller].initSearchCriteria.clear();
                ApiServices[this.state.controller].initOrderCriteria.clear();
                // ApiServices[this.state.controller].orderCriteria.addDesc("fechaSolicitud");
                ApiServices[this.state.controller].initSearchCriteria.setOperator("and");              
                ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud",8);
                ApiServices[this.state.controller].initOrderCriteria.addAsc("datosSolicitudEmpadronamiento.idSolicitud");
                // let response =  await ApiServices[this.state.controller].listRegisterCriteria();
                // let data= [];
                // if (response.error!==null)      Alert.error(response.error.message);
                // else if (response.data!=="")   data= response.data;            
                this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
            }
        }catch(exception){
            (exception.status===404) ? Alert.error("Falla del sistema"): Alert.error("Intente de nuevo ");
            this.setState({ loading: false,checkAutorization: false  });
        }
    }
    async componentDidMount() {  this.showList();    }
    
    abrirObservacion(){
        this.setState({ openObservacion: true })
    }
    cerrarObservacion(){
        this.setState({ openObservacion: false })
    }
   
    render() {
        if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/> 
        // if (!this.state.authorized &&  !this.state.loading){ return <NotAuthorized/>} //  QUITAR CUANDO SE TENGA ENDPOINT 
        {/* if (this.state.create){ return <New     showList={this.showList} elements={this.state.elements} controller={this.state.controller}/> }
        */}
        if (this.state.loading ) return <LoadingSpinner open={this.state.loading}/> 
        return (
            <div>
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}      
                <ModalObservation open={this.state.openObservacion}  handleClose={this.cerrarObservacion} textoObservacion={this.state.textoObservacion} title={this.state.title} />                
                {window.screen.width >= 1024 ? (
                    <Table  pageSize={this.state.pageSize} 
                            title={"Listado de solicitudes de Inconsistencias"}
                            header = {this.state.header}
                            service={ApiServices[this.state.controller]}
                            refreshList={this.showList}
                            detailPanel={this.state.detailPanel}
                            addRegister={this.addRegister}
                            data={this.state.data} 
                            showSearcher={false}
                            showFilterGeneral={false}
                    />
                ) : (<ListElement/>) }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesCasosEspeciales);